import * as THREE from 'three';
import * as SceneModule from '../scene.js';
import { pointMaterial } from './material.js';

// Tile state
export const state = { 
  tileSize: 44, 
  tilesX: 5, 
  tilesZ: 4, 
  scrollSpeed: 3.0 
};

export const scrollOffset = new THREE.Vector2(0, 0);

// Tiles array
let tilesPoints = [];

export function getTilesPoints() {
  return tilesPoints;
}

export { tilesPoints };

// Segments for geometry
let segments = 256;

export function setSegments(newSegments) {
  segments = newSegments;
}

export function getSegments() {
  return segments;
}

function buildBaseGeometry() {
  const g = new THREE.PlaneGeometry(state.tileSize, state.tileSize, segments, segments);
  g.rotateX(-Math.PI / 2);
  return g;
}

function positiveModulo(v, m) { 
  return ((v % m) + m) % m; 
}

export function updateTileMatrices() {
  if (!tilesPoints || tilesPoints.length === 0) return;
  let idx = 0;
  const offsetX = (state.tilesX - 1) * state.tileSize * 0.5;
  const offsetZ = (state.tilesZ - 1) * state.tileSize * 0.5;
  const modX = positiveModulo(scrollOffset.x, state.tileSize);
  const modZ = positiveModulo(scrollOffset.y, state.tileSize);
  for (let z = 0; z < state.tilesZ; z++) {
    for (let x = 0; x < state.tilesX; x++) {
      const px = (x * state.tileSize) - offsetX - modX;
      const pz = (z * state.tileSize) - offsetZ - modZ;
      const pts = tilesPoints[idx++];
      if (pts) pts.position.set(px, 0, pz);
    }
  }
}

export function rebuildTiling() {
  const { scene } = SceneModule;
  if (tilesPoints && tilesPoints.length) {
    for (const p of tilesPoints) {
      scene.remove(p);
      if (p.geometry) p.geometry.dispose();
    }
  }
  tilesPoints = [];
  const geometry = buildBaseGeometry();
  geometry.deleteAttribute('normal');
  geometry.deleteAttribute('tangent');
  // Ensure each vertex becomes a point; PlaneGeometry already has indexed triangles.
  // Convert to non-indexed so every vertex is unique for gl.POINTS
  const nonIndexed = geometry.toNonIndexed();
  nonIndexed.computeBoundingSphere();
  for (let z = 0; z < state.tilesZ; z++) {
    for (let x = 0; x < state.tilesX; x++) {
      const pts = new THREE.Points(nonIndexed, pointMaterial);
      pts.frustumCulled = false;
      tilesPoints.push(pts);
      scene.add(pts);
    }
  }
  updateTileMatrices();
}
